import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  EditAccountModal,
  EditReportingProgramModal,
  EditDinerProfileModal,
  SearchViaHubSpotModal,
  EditAccountContactModal,
} from '@containers/account/edit'
import { EditBatchOrderModal } from '@containers/batchOrder/edit'
import { EditChefModal } from '@containers/chef/edit'
import {
  EditChildChefsModal,
  ChefFutureOrdersModal,
} from '@containers/chef/chefSections'
import { EditChefContactModal, CalcChefFeesModal } from '@containers/chef/edit'
import { EditChefPayoutsModal } from '@containers/order/edit'
import { EditChildMenuItemModal } from '@containers/chef/edit'
import { EditDeliveryZoneModal } from '@containers/market/edit'
import { EditMenuConceptModal } from '@containers/chef/edit'
import { EditHQModal } from '@containers/market/edit'
import { EditOrderModal } from '@containers/order/edit'
import { EditRecipeModal } from '@containers/chef/edit'
import { EditProposalModal } from '@containers/proposal/edit'
import { EditServiceDepotModal } from '@containers/market/edit'
import { EditServiceItemModal } from '@containers/chef/edit'
import { EditSnackPackModal } from '@containers/chef/edit'
import { EditVirtualItemModal } from '@containers/chef/edit'
import { EditVirtualKitModal } from '@containers/chef/edit'
import { EditUserModal } from '@containers/user/edit'
import {
  AuditHistoryModal,
  ResultsMessageModal,
  InfoModal,
  EditVendorPricingAgreementModal,
  EditPDFModal,
} from '@containers/common/modal'

class Modals extends Component {
  render() {
    const {
      showCalcChefFeesModal,
      showAccount,
      showDinerProfile,
      showClientReportingProgram,
      showAccountContact,
      showAuditHistory,
      showBatchOrder,
      showChef,
      showChefContact,
      showChefPayouts,
      showChildMenuItem,
      showConcepts,
      showDeliveryZone,
      showHQ,
      showOrder,
      showRecipe,
      showProposal,
      showSearchViaHubSpotModal,
      showServiceDepot,
      showServiceItem,
      showSnackPack,
      showVirtualItem,
      showVirtualKit,
      showUser,
      showEditChildChefs,
      showChefFutureOrders,
      showInfoModal,
      showResultsMessageModal,
      showEditVendorPricingAgreement,
      showEditPDFModal,
    } = this.props

    return (
      <div>
        {showAccount && <EditAccountModal />}
        {showAccountContact && <EditAccountContactModal />}
        {showBatchOrder && <EditBatchOrderModal />}
        {showChefPayouts && <EditChefPayoutsModal />}
        {showChef && <EditChefModal />}
        {showChefContact && <EditChefContactModal />}
        {showChildMenuItem && <EditChildMenuItemModal />}
        {showClientReportingProgram && <EditReportingProgramModal />}
        {showChefFutureOrders && <ChefFutureOrdersModal />}
        {showConcepts && <EditMenuConceptModal />}
        {showDinerProfile && <EditDinerProfileModal />}
        {showDeliveryZone && <EditDeliveryZoneModal />}
        {showHQ && <EditHQModal />}
        {showOrder && <EditOrderModal />}
        {showRecipe && <EditRecipeModal />}
        {showProposal && <EditProposalModal />}
        {showResultsMessageModal && <ResultsMessageModal />}
        {showSearchViaHubSpotModal && <SearchViaHubSpotModal />}
        {showServiceDepot && <EditServiceDepotModal />}
        {showServiceItem && <EditServiceItemModal />}
        {showSnackPack && <EditSnackPackModal />}
        {showVirtualItem && <EditVirtualItemModal />}
        {showVirtualKit && <EditVirtualKitModal />}
        {showUser && <EditUserModal />}
        {showEditChildChefs && <EditChildChefsModal />}
        {showCalcChefFeesModal && <CalcChefFeesModal />}
        {showAuditHistory && <AuditHistoryModal />}
        {showInfoModal && <InfoModal />}
        {showEditVendorPricingAgreement && <EditVendorPricingAgreementModal />}
        {showEditPDFModal && <EditPDFModal />}
      </div>
    )
  }
}

Modals.propTypes = {
  showCalcChefFeesModal: PropTypes.bool,
  showAccount: PropTypes.bool,
  showAccountContact: PropTypes.bool,
  showAuditHistory: PropTypes.bool,
  showBatchOrder: PropTypes.bool,
  showChef: PropTypes.bool,
  showChefContact: PropTypes.bool,
  showChefPayouts: PropTypes.bool,
  showChildMenuItem: PropTypes.bool,
  showClientReportingProgram: PropTypes.bool,
  showConcepts: PropTypes.bool,
  showDinerProfile: PropTypes.bool,
  showDeliveryZone: PropTypes.bool,
  showEditPDFModal: PropTypes.bool,
  showHQ: PropTypes.bool,
  showOrder: PropTypes.bool,
  showRecipe: PropTypes.bool,
  showProposal: PropTypes.bool,
  showSearchViaHubSpotModal: PropTypes.bool,
  showServiceDepot: PropTypes.bool,
  showServiceItem: PropTypes.bool,
  showSnackPack: PropTypes.bool,
  showVirtualItem: PropTypes.bool,
  showVirtualKit: PropTypes.bool,
  showUser: PropTypes.bool,
  showEditChildChefs: PropTypes.bool,
  showChefFutureOrders: PropTypes.bool,
  showResultsMessageModal: PropTypes.bool,
  showInfoModal: PropTypes.bool,
  showEditVendorPricingAgreement: PropTypes.bool,
}

export default Modals
